const treemapdata = {
    "name": "nivo",
    "color": "hsl(132, 70%, 50%)",
    "children": [
        {
            "name": "viz",
            "color": "hsl(175, 70%, 50%)",
            "children": [
                {
                    "name": "stack",
                    "color": "hsl(107, 70%, 50%)",
                    "children": [
                        {
                            "name": "cchart",
                            "color": "hsl(294, 70%, 50%)",
                            "loc": 104806
                        },
                        {
                            "name": "xAxis",
                            "color": "hsl(80, 70%, 50%)",
                            "loc": 179140
                        },
                        {
                            "name": "yAxis",
                            "color": "hsl(213, 70%, 50%)",
                            "loc": 136129
                        },
                        {
                            "name": "layers",
                            "color": "hsl(336, 70%, 50%)",
                            "loc": 141382
                        }
                    ]
                },
                {
                    "name": "ppie",
                    "color": "hsl(310, 70%, 50%)",
                    "children": [
                        {
                            "name": "chart",
                            "color": "hsl(312, 70%, 50%)",
                            "children": [
                                {
                                    "name": "pie",
                                    "color": "hsl(133, 70%, 50%)",
                                    "children": [
                                        {
                                            "name": "outline",
                                            "color": "hsl(206, 70%, 50%)",
                                            "loc": 13635
                                        },
                                        {
                                            "name": "slices",
                                            "color": "hsl(358, 70%, 50%)",
                                            "loc": 94662
                                        },
                                        {
                                            "name": "bbox",
                                            "color": "hsl(156, 70%, 50%)",
                                            "loc": 199099
                                        }
                                    ]
                                },
                                {
                                    "name": "donut",
                                    "color": "hsl(239, 70%, 50%)",
                                    "loc": 79834
                                },
                                {
                                    "name": "gauge",
                                    "color": "hsl(140, 70%, 50%)",
                                    "loc": 78900
                                }
                            ]
                        },
                        {
                            "name": "legends",
                            "color": "hsl(329, 70%, 50%)",
                            "loc": 137315
                        }
                    ]
                }
            ]
        },
        {
            "name": "colors",
            "color": "hsl(101, 70%, 50%)",
            "children": [
                {
                    "name": "rgb",
                    "color": "hsl(88, 70%, 50%)",
                    "loc": 34554
                },
                {
                    "name": "hsl",
                    "color": "hsl(187, 70%, 50%)",
                    "loc": 95889
                }
            ]
        },
        {
            "name": "utils",
            "color": "hsl(109, 70%, 50%)",
            "children": [
                {
                    "name": "randomize",
                    "color": "hsl(337, 70%, 50%)",
                    "loc": 141030
                },
                {
                    "name": "resetClock",
                    "color": "hsl(188, 70%, 50%)",
                    "loc": 118891
                },
                {
                    "name": "noop",
                    "color": "hsl(114, 70%, 50%)",
                    "loc": 174548
                },
                {
                    "name": "tick",
                    "color": "hsl(133, 70%, 50%)",
                    "loc": 94347
                },
                {
                    "name": "forceGC",
                    "color": "hsl(287, 70%, 50%)",
                    "loc": 69276
                },
                {
                    "name": "stackTrace",
                    "color": "hsl(288, 70%, 50%)",
                    "loc": 77631
                },
                {
                    "name": "dbg",
                    "color": "hsl(97, 70%, 50%)",
                    "loc": 165896
                }
            ]
        },
        {
            "name": "generators",
            "color": "hsl(244, 70%, 50%)",
            "children": [
                {
                    "name": "address",
                    "color": "hsl(267, 70%, 50%)",
                    "loc": 81931
                },
                {
                    "name": "city",
                    "color": "hsl(208, 70%, 50%)",
                    "loc": 153770
                },
                {
                    "name": "animal",
                    "color": "hsl(53, 70%, 50%)",
                    "loc": 194851
                },
                {
                    "name": "movie",
                    "color": "hsl(74, 70%, 50%)",
                    "loc": 153223
                },
                {
                    "name": "user",
                    "color": "hsl(69, 70%, 50%)",
                    "loc": 111570
                }
            ]
        },
        {
            "name": "set",
            "color": "hsl(208, 70%, 50%)",
            "children": [
                {
                    "name": "clone",
                    "color": "hsl(241, 70%, 50%)",
                    "loc": 81510
                },
                {
                    "name": "intersect",
                    "color": "hsl(204, 70%, 50%)",
                    "loc": 21556
                },
                {
                    "name": "merge",
                    "color": "hsl(276, 70%, 50%)",
                    "loc": 124150
                },
                {
                    "name": "reverse",
                    "color": "hsl(104, 70%, 50%)",
                    "loc": 124034
                },
                {
                    "name": "toArray",
                    "color": "hsl(60, 70%, 50%)",
                    "loc": 189124
                },
                {
                    "name": "toObject",
                    "color": "hsl(21, 70%, 50%)",
                    "loc": 147652
                },
                {
                    "name": "fromCSV",
                    "color": "hsl(108, 70%, 50%)",
                    "loc": 36216
                },
                {
                    "name": "slice",
                    "color": "hsl(127, 70%, 50%)",
                    "loc": 3345
                },
                {
                    "name": "append",
                    "color": "hsl(166, 70%, 50%)",
                    "loc": 84714
                },
                {
                    "name": "prepend",
                    "color": "hsl(270, 70%, 50%)",
                    "loc": 109673
                },
                {
                    "name": "shuffle",
                    "color": "hsl(358, 70%, 50%)",
                    "loc": 148138
                },
                {
                    "name": "pick",
                    "color": "hsl(222, 70%, 50%)",
                    "loc": 99094
                },
                {
                    "name": "plouc",
                    "color": "hsl(108, 70%, 50%)",
                    "loc": 9434
                }
            ]
        },
        {
            "name": "text",
            "color": "hsl(216, 70%, 50%)",
            "children": [
                {
                    "name": "trim",
                    "color": "hsl(134, 70%, 50%)",
                    "loc": 130640
                },
                {
                    "name": "slugify",
                    "color": "hsl(154, 70%, 50%)",
                    "loc": 141842
                },
                {
                    "name": "snakeCase",
                    "color": "hsl(241, 70%, 50%)",
                    "loc": 160919
                },
                {
                    "name": "camelCase",
                    "color": "hsl(32, 70%, 50%)",
                    "loc": 93199
                },
                {
                    "name": "repeat",
                    "color": "hsl(40, 70%, 50%)",
                    "loc": 188554
                },
                {
                    "name": "padLeft",
                    "color": "hsl(21, 70%, 50%)",
                    "loc": 99466
                },
                {
                    "name": "padRight",
                    "color": "hsl(83, 70%, 50%)",
                    "loc": 55949
                },
                {
                    "name": "sanitize",
                    "color": "hsl(245, 70%, 50%)",
                    "loc": 143833
                },
                {
                    "name": "ploucify",
                    "color": "hsl(108, 70%, 50%)",
                    "loc": 50389
                }
            ]
        },
        {
            "name": "misc",
            "color": "hsl(232, 70%, 50%)",
            "children": [
                {
                    "name": "greetings",
                    "color": "hsl(161, 70%, 50%)",
                    "children": [
                        {
                            "name": "hey",
                            "color": "hsl(100, 70%, 50%)",
                            "loc": 5302
                        },
                        {
                            "name": "HOWDY",
                            "color": "hsl(94, 70%, 50%)",
                            "loc": 29044
                        },
                        {
                            "name": "aloha",
                            "color": "hsl(32, 70%, 50%)",
                            "loc": 64616
                        },
                        {
                            "name": "AHOY",
                            "color": "hsl(205, 70%, 50%)",
                            "loc": 53853
                        }
                    ]
                },
                {
                    "name": "other",
                    "color": "hsl(46, 70%, 50%)",
                    "loc": 7331
                },
                {
                    "name": "path",
                    "color": "hsl(41, 70%, 50%)",
                    "children": [
                        {
                            "name": "pathA",
                            "color": "hsl(292, 70%, 50%)",
                            "loc": 106690
                        },
                        {
                            "name": "pathB",
                            "color": "hsl(97, 70%, 50%)",
                            "children": [
                                {
                                    "name": "pathB1",
                                    "color": "hsl(196, 70%, 50%)",
                                    "loc": 93240
                                },
                                {
                                    "name": "pathB2",
                                    "color": "hsl(50, 70%, 50%)",
                                    "loc": 76387
                                },
                                {
                                    "name": "pathB3",
                                    "color": "hsl(65, 70%, 50%)",
                                    "loc": 148047
                                },
                                {
                                    "name": "pathB4",
                                    "color": "hsl(181, 70%, 50%)",
                                    "loc": 121077
                                }
                            ]
                        },
                        {
                            "name": "pathC",
                            "color": "hsl(298, 70%, 50%)",
                            "children": [
                                {
                                    "name": "pathC1",
                                    "color": "hsl(121, 70%, 50%)",
                                    "loc": 127419
                                },
                                {
                                    "name": "pathC2",
                                    "color": "hsl(134, 70%, 50%)",
                                    "loc": 87161
                                },
                                {
                                    "name": "pathC3",
                                    "color": "hsl(53, 70%, 50%)",
                                    "loc": 55924
                                },
                                {
                                    "name": "pathC4",
                                    "color": "hsl(121, 70%, 50%)",
                                    "loc": 30465
                                },
                                {
                                    "name": "pathC5",
                                    "color": "hsl(318, 70%, 50%)",
                                    "loc": 126145
                                },
                                {
                                    "name": "pathC6",
                                    "color": "hsl(311, 70%, 50%)",
                                    "loc": 50818
                                },
                                {
                                    "name": "pathC7",
                                    "color": "hsl(254, 70%, 50%)",
                                    "loc": 104144
                                },
                                {
                                    "name": "pathC8",
                                    "color": "hsl(4, 70%, 50%)",
                                    "loc": 112361
                                },
                                {
                                    "name": "pathC9",
                                    "color": "hsl(182, 70%, 50%)",
                                    "loc": 164655
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ]
}
export default treemapdata;